export default "__VITE_ASSET__56a04d54__"